/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import { createRoot } from "react-dom/client"
export {  wrapRootElement } from "./src/services/fpjs-provider"

export const replaceHydrateFunction = () => {
  return (element, container) => {
    createRoot(container).render(element)
  }
}
